// 获取文件链接中的文件名
export const getFileName = (url) => {
  const regex = /\/([^/?#]+)(\?|$)/; // 从最后一个斜杠后提取非斜杠、问号或井号的字符，直到问号或字符串结束
  const match = url.match(regex);
  return match ? match[1] : null;
};

export const downloadFile = (url) => {
  const realName = getFileName(url);
  const filename = realName.indexOf(".") !== -1 ? realName : realName + ".zip";
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
};
